import http from "@/helper/http";
import {BaseVO, GetByIdBO, PaginationBO, PaginationVO} from "@/model/global";
import {useMutation, useQuery} from "@tanstack/react-query";
import {ReviewStatusVO} from "@/service/instance.s";
import {ProjectPO} from "@/model/product";
import {WriteProjectForm} from "@/pages/Project/WriteProject";
import {ContractPO} from "@/model/customer";
import {PaybackPO} from "@/model/finance";
import {AssignProductForm} from "@/widget/ProcessApproval/AssignProduct";

export enum ProjectEnum {
    GetProjectPage = "/project/getProjectPage",
    GetProject = "/project/getProject",
    CreateProject = "/project/createProject",
    UpdateProject = "/project/updateProject",
    AssignProject = "/project/assignProject",
    SearchProject = "/project/searchProject",
}

export interface ProjectPageBO extends PaginationBO {
    keyword?: string;
    contractId?: number
}

export interface ProjectPageVO extends ReviewStatusVO, ProjectPO {
    instanceId: number
}

export interface ProjectVO extends ProjectPO {
    contract: ContractPO
    startDate: string;
    endDate: string;
    mobile: string;
    paybacks: PaybackPO[]
    contact: string;
    level: string;
    section: string;
    kind: string;
}

export interface SearchProjectBO {
    keyword: string;
}

export interface SearchProjectVO {
    id: number
    category: string
}

export const useQueryProjectPage = (writeStatus: number) => useMutation({
    mutationFn: (data: ProjectPageBO) => http.post<BaseVO<PaginationVO<ProjectPageVO>>>({
        url: `${ProjectEnum.GetProjectPage}/${writeStatus}`,
        data: data,
    }),
})

export const useCreateProject = () => useMutation({
    mutationFn: (data: WriteProjectForm) => http.put({url: ProjectEnum.CreateProject, data}),
})

export const useUpdateProject = () => useMutation({
    mutationFn: (data: WriteProjectForm) => http.post({url: ProjectEnum.UpdateProject, data}),
})

export const useAssignProject = () => useMutation({
    mutationFn: ({instanceId, businessId, ...rest}: AssignProductForm) => http.post({
        url: ProjectEnum.AssignProject,
        data: {...rest, businessId: businessId.toString(), instanceId: instanceId.toString()}
    }),
})

export const useQueryProject = (params: GetByIdBO, enabled = true) => useQuery<BaseVO<ProjectVO>>({
    queryKey: [params.id], queryFn: () => http.get<BaseVO<ProjectVO>>({
        url: ProjectEnum.GetProject,
        params: params
    }),
    enabled
})

export const useSearchProject = () => useMutation({
    mutationFn: (data: SearchProjectBO) => http.post<BaseVO<SearchProjectVO[]>>({
        url: ProjectEnum.SearchProject,
        data
    }),
})


